import { formatDateTime } from '../../../shared/offer-domain/counter';
import { DateFormatmmmyyyy } from '../../../utils/dateformatter';

export const BUYER_NAME = 'PT Pertamina Patra Niaga';

const isSpotPeriod = (contractType, period) => {
  if (contractType != null && contractType !== '') {
    return parseInt(contractType, 10) === 2;
  }
  return String(period || '').toUpperCase() === 'SPOT';
};

export const buildProcurementHeader = (source = {}) => {
  const period = source.period ?? null;
  const isSpot = isSpotPeriod(source.contractType, period);

  return {
    procurementNumber: source.procurementNumber ?? source.idProc ?? null,
    titleProcurement: source.titleProcurement ?? source.title ?? null,
    contractType: source.contractType ?? (isSpot ? 2 : 1),
    isSpot,
    contractPeriodSpot: source.contractPeriodSpot ?? null,
    contractPeriodTermStart: source.contractPeriodTermStart ?? null,
    contractPeriodTermEnd: source.contractPeriodTermEnd ?? null,
    periodLabel: period,
    productName: source.productName ?? source.productTypeBold ?? null,
    productTypeName: source.productTypeName ?? source.productTypeMuted ?? null,
    updatedDate: source.updatedDate ?? source.updateDate ?? null,
    proposalValidityPeriodMax: source.proposalValidityPeriodMax ?? null,
    buyerName: source.buyerName || BUYER_NAME,
  };
};

export const getContractPeriodDisplay = header => {
  if (header?.isSpot) {
    return {
      label: 'Period',
      value:
        DateFormatmmmyyyy(
          header.contractPeriodSpot || header.contractPeriodTermStart
        ) ||
        header.periodLabel ||
        null,
    };
  }

  const start = DateFormatmmmyyyy(header?.contractPeriodTermStart) || '';
  const end = header?.contractPeriodTermEnd
    ? DateFormatmmmyyyy(header.contractPeriodTermEnd)
    : '';

  return {
    label: 'Contract Period',
    value: end ? `${start} - ${end}` : start || header?.periodLabel || null,
  };
};

export const getProductLabel = header =>
  [header?.productName, header?.productTypeName].filter(Boolean).join(' · ');

export const buildOfferFacts = ({ procurement, sellerName }) => {
  const period = getContractPeriodDisplay(procurement);

  return [
    {
      icon: 'ri-building-4-line',
      label: 'Buyer',
      value: procurement?.buyerName || BUYER_NAME,
    },
    {
      icon: 'ri-store-2-line',
      label: 'Seller',
      value: sellerName || null,
    },
    {
      icon: 'ri-drop-line',
      label: 'Product',
      value: getProductLabel(procurement),
    },
    {
      icon: 'ri-calendar-2-line',
      label: period.label,
      value: period.value,
    },
    {
      icon: 'ri-shield-check-line',
      label: 'Offer valid to',
      value: formatDateTime(procurement?.proposalValidityPeriodMax),
    },
  ];
};
